import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;
const EMPTY = { nome: "", azienda: "", email: "", messaggio: "", privacy: false, website: "" };
const inputCls = "w-full border-0 border-b border-ink/25 bg-transparent px-0 py-3 text-base text-ink placeholder:text-ink/45 transition-colors focus:border-teal focus:outline-none focus:ring-0";

const FieldWrap = ({ id, label, required, children }) => (
  <div>
    <label htmlFor={id} className="eyebrow">{label}{required && <span aria-hidden="true"> *</span>}</label>
    <div className="mt-2">{children}</div>
  </div>
);

export const ContactForm = () => {
  const [form, setForm] = useState(EMPTY);
  const [status, setStatus] = useState("idle");
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!API) { toast.error("Modulo non configurato. Scrivici direttamente via email."); return; }
    setStatus("loading");
    try {
      await axios.post(`${API}/api/contact`, form);
      setStatus("done");
      setForm(EMPTY);
    } catch (err) {
      setStatus("idle");
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Controlla i campi e riprova, oppure scrivici via email.");
    }
  };

  if (status === "done") {
    return (
      <div className="border border-teal/30 bg-mint p-8 text-teal md:p-12" role="status" data-testid="contact-success">
        <p className="font-serif text-3xl md:text-4xl">Grazie, abbiamo ricevuto il tuo messaggio.</p>
        <p className="mt-4 text-base leading-relaxed">Ti risponderemo il prima possibile all'indirizzo che ci hai indicato.</p>
        <button type="button" onClick={() => setStatus("idle")} className="link-u mt-8 text-sm" data-testid="contact-new">Invia un'altra richiesta</button>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-10" noValidate={false} data-testid="contact-form">
      <div className="grid gap-10 md:grid-cols-2">
        <FieldWrap id="nome" label="Nome" required>
          <input id="nome" required minLength={2} autoComplete="name" value={form.nome} onChange={set("nome")} className={inputCls} placeholder="Il tuo nome" data-testid="contact-nome" />
        </FieldWrap>
        <FieldWrap id="azienda" label="Azienda">
          <input id="azienda" autoComplete="organization" value={form.azienda} onChange={set("azienda")} className={inputCls} placeholder="Nome dell'azienda o attività" data-testid="contact-azienda" />
        </FieldWrap>
      </div>
      <FieldWrap id="email" label="Email" required>
        <input id="email" type="email" required autoComplete="email" value={form.email} onChange={set("email")} className={inputCls} placeholder="nome@azienda.it" data-testid="contact-email" />
      </FieldWrap>
      <FieldWrap id="messaggio" label="Messaggio" required>
        <textarea id="messaggio" required minLength={10} rows={5} value={form.messaggio} onChange={set("messaggio")} className={`${inputCls} resize-none`} placeholder="Raccontaci il tuo brand e di cosa hai bisogno" data-testid="contact-messaggio" />
      </FieldWrap>
      <input type="text" name="website" tabIndex={-1} autoComplete="off" value={form.website} onChange={set("website")} className="hidden" aria-hidden="true" />
      <label className="flex cursor-pointer items-start gap-3 text-sm leading-relaxed text-ink/80">
        <input type="checkbox" required checked={form.privacy} onChange={set("privacy")} className="mt-1 h-4 w-4 accent-teal" data-testid="contact-privacy" />
        <span>Dichiaro di aver letto l'<Link to="/privacy" className="text-teal underline underline-offset-4">informativa privacy</Link>. I dati saranno usati solo per rispondere alla mia richiesta. *</span>
      </label>
      <button type="submit" disabled={status === "loading"} className="group inline-flex items-center gap-3 bg-ink px-8 py-4 text-sm font-medium tracking-[0.06em] text-paper transition-colors duration-500 hover:bg-teal disabled:opacity-60" data-testid="contact-submit">
        {status === "loading" ? "Invio in corso…" : "Invia la richiesta"}
        <span className="transition-transform duration-500 group-hover:translate-x-1" aria-hidden="true">→</span>
      </button>
    </form>
  );
};
